import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from "./Home";
import Login from "./Login";
import Configs from "./Configs";

const Rotas = () => {

  let user = localStorage.getItem('@director/usr');
  user = JSON.parse(user);

  const routes = [
    { path: "/", element: <Home /> },
  ]

  if (user && user.id === 1) {
    routes.push({ path: "/configs", element: <Configs /> });
  }

  return (
    <Routes>
      <Route path={'/login'} element={<Login />} />
      {routes?.map((route, idx) => {
        return (
          <Route
            key={idx}
            path={route.path}
            element={
              <div className='container-fluid mt-3'>{route.element}</div>
            }
          />
        );
      })}
    </Routes>
  )
}
export default Rotas;